import React from 'react';

const ImagePlaceholder = () => (
    <div className="w-full h-full bg-gray-200 border border-gray-300 flex items-center justify-center">
        <p className="text-xs text-gray-500">Photo</p>
    </div>
);

const IDCard = React.forwardRef(({ user }, ref) => {
  if (!user) return null;

  const profileUrl = `https://members.abssvss.com/member/${user.memberId}`;

  return (
    <div ref={ref} className="bg-white p-6 rounded-lg shadow-xl w-96 border border-gray-200 font-sans text-gray-800">
      <div className="text-center border-b-2 border-brand-accent pb-4 mb-4">
        <h2 className="text-xl font-bold text-brand-primary">AKHIL BHARATIYA SHREE SWAMI VIVEKANAND SHIKSHA SANSTHAN</h2>
        <p className="text-sm font-medium">Membership ID Card</p>
      </div>
      <div className="flex">
        <div className="w-2/3 pr-4">
          <p className="text-lg font-bold leading-tight">{user.firstName} {user.lastName || ''}</p>
          <p className="text-sm text-gray-600">{user.position || 'Member'}</p>
          <hr className="my-2" />
          <p className="text-xs"><span className="font-semibold">Member ID:</span> {user.memberId}</p>
          <p className="text-xs"><span className="font-semibold">State:</span> {user.state || 'N/A'}</p>
        </div>
        <div className="w-1/3 flex flex-col items-center">
          <div className="w-24 h-24 mb-2 overflow-hidden">
            {user.profilePictureUrl ? (
                <img src={`https://members.abssvss.com${user.profilePictureUrl}`} alt="Profile" className="w-full h-full object-cover" />
            ) : (
                <ImagePlaceholder />
            )}
          </div>
          <img 
            src={`https://api.qrserver.com/v1/create-qr-code/?size=96x96&data=${encodeURIComponent(profileUrl)}`} 
            alt="QR Code linking to profile" 
            className="w-24 h-24"
          />
        </div>
      </div>
    </div>
  );
});

export default IDCard;

